export function getCultureFromLanguage(language: string) {
  if (language.toLowerCase().startsWith('de')) return 'DE-de'
  return 'EN-us'
}
